// eslint-disable-next-line import/prefer-default-export
export enum RoleType {
  PARENT = 'PARENT',
  STUDENT = 'STUDENT'
}
